import { render } from "./Actions.vue?vue&type=template&id=2555b71e&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=2555b71e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2555b71e"]])

export default __exports__